export default "__VITE_ASSET__DgTT9awt__"